import React, { useEffect, useState } from 'react';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { getAllDocuments } from 'nursd-dashboard/api/documents';
import DocumentTable from './table/DocumentTable';
import PropTypes from 'prop-types';

const TabTwo = ({ nurseId }) => {
  const { authToken } = useAuth();
  const [documentData, setDocumentData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const checkUser = async (authToken, id) => {
    try {
      await getAllDocuments(authToken, id).then(res => setDocumentData(res));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (nurseId !== null) {
      checkUser(authToken, nurseId);
    }
  }, [nurseId, refresh]);

  return (
    <>
      <DocumentTable
        documentData={documentData}
        nurseId={nurseId}
        refresh={refresh}
        setRefresh={setRefresh}
      />
    </>
  );
};

TabTwo.propTypes = {
  nurseId: PropTypes.number
};

export default TabTwo;
